var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "columns is-centered login-container " }, [
    _c(
      "div",
      { staticClass: "column is-12-mobile is-8" },
      [
        _vm.showLoader
          ? _c("BaseLoader", { staticClass: "login-loader" })
          : _vm._e(),
        _vm._v(" "),
        !_vm.flow.smsSent && !_vm.loggedIn && !_vm.skipToPin
          ? _c("div", [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("div", [
                _c("div", { staticClass: "field has-addons" }, [
                  _c("div", { staticClass: "control is-expanded" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.phone,
                          expression: "phone"
                        },
                        { name: "focus", rawName: "v-focus" }
                      ],
                      staticClass: "input input--login",
                      class: _vm.liveValidate ? "is-success" : "is-danger",
                      attrs: {
                        type: "tel",
                        placeholder: "(607) 123 4567",
                        "aria-label": "Enter your mobile phone number here."
                      },
                      domProps: { value: _vm.phone },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.submitRequest($event)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.phone = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _c("BaseButton", {
                    attrs: {
                      title: "Send Pin",
                      classNames: ["button--modifier"]
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.submitRequest($event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(2)
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.flow.smsSent && !_vm.loggedIn
          ? _c("div", [
              _vm._m(3),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "field half-width" }, [
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.login.token,
                        expression: "login.token"
                      },
                      { name: "focus", rawName: "v-focus" }
                    ],
                    staticClass: "input base-input-border",
                    attrs: {
                      type: "tel",
                      placeholder: "00000",
                      "aria-label":
                        "Enter the pin that was sent to your phone here."
                    },
                    domProps: { value: _vm.login.token },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.submitRequest($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.login, "token", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _c("BaseButton", {
                    attrs: {
                      title: "Verify",
                      classNames: ["button--modifier"]
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.submitRequest($event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "tp-link",
                      attrs: {
                        "aria-label":
                          "click here to receive a voice call with your pin number"
                      },
                      on: { click: _vm.handleSendVoicePin }
                    },
                    [
                      _vm._v("\n\t\t\t\t\t\tTrouble receiving PIN?"),
                      _c("br"),
                      _vm._v("\n\t\t\t\t\t\tClick "),
                      _c("span", { staticClass: "underline-link" }, [
                        _vm._v("here")
                      ]),
                      _vm._v(" to get your PIN in a call.\n\t\t\t\t\t")
                    ]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("p", { class: _vm.messageClass }, [_vm._v(_vm._s(_vm.msg))])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "has-text-centered" }, [
      _c("p", { staticClass: "is-size-1" }, [_vm._v("😊")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label is-size-4 heading-txt" }, [
        _c("b", [_vm._v("Login/Sign Up with your Mobile Number")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "is-size-7 has-text-grey-light" }, [
      _vm._v(
        "\n                        By clicking on Send Pin, you agree to our\n                        "
      ),
      _c("u", [
        _c(
          "a",
          {
            staticClass: "has-text-grey-light",
            attrs: {
              target: "_blank",
              href: "https://www.touchpoint.io/privacy.php"
            }
          },
          [
            _vm._v(
              "\n                                Terms of Service\n                            "
            )
          ]
        )
      ]),
      _vm._v("\n                        and\n                        "),
      _c("u", [
        _c(
          "a",
          {
            staticClass: "has-text-grey-light",
            attrs: {
              target: "_blank",
              href: "https://www.touchpoint.io/privacy.php"
            }
          },
          [
            _vm._v(
              "\n                                Privacy Policy\n                            "
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "has-text-centered" }, [
      _c("p", { staticClass: "is-size-1" }, [_vm._v("💬")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label is-size-4 heading-txt" }, [
        _c("b", [
          _vm._v("Thanks! "),
          _c("br"),
          _vm._v(" Enter the PIN we just sent")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bab3132", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bab3132","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Login.vue
// module id = null
// module chunks = 